module.exports = __webpack_public_path__ + "static/media/oshiri.aab993e5.png";